"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseService_1 = __importDefault(require("../../Core/BaseService"));
var SERVICE_NAME = '/own-fleet-optimization-service/speed_factor';
var SpeedFactorService = /** @class */ (function (_super) {
    __extends(SpeedFactorService, _super);
    function SpeedFactorService(session) {
        return _super.call(this, session, 'speedFactor') || this;
    }
    SpeedFactorService.prototype.create = function (payload) {
        return this.routeGenerator.post(SERVICE_NAME).withPayload(payload).invoke();
    };
    SpeedFactorService.prototype.list = function (serviceAreaId) {
        return this.routeGenerator.get("".concat(SERVICE_NAME, "/").concat(serviceAreaId)).invoke();
    };
    SpeedFactorService.prototype.update = function (payload) {
        return this.routeGenerator.put(SERVICE_NAME).withPayload(payload).invoke();
    };
    SpeedFactorService.prototype.updateSeries = function (payload) {
        return this.routeGenerator.put("".concat(SERVICE_NAME, "/series")).withPayload(payload).invoke();
    };
    SpeedFactorService.prototype.delete = function (dbId) {
        return this.routeGenerator.delete("".concat(SERVICE_NAME, "/db_id/").concat(dbId)).invoke();
    };
    SpeedFactorService.prototype.deleteSeries = function (originalUuid) {
        return this.routeGenerator.delete("".concat(SERVICE_NAME, "/series/").concat(originalUuid)).invoke();
    };
    return SpeedFactorService;
}(BaseService_1.default));
exports.default = SpeedFactorService;
//# sourceMappingURL=SpeedFactor.service.js.map